var SchemaBuilder = /** @class */ (function () {
    function SchemaBuilder(schema, model, fieldName) {
        this.schema = schema;
        this.model = model;
        this.fieldName = fieldName;
    }
    SchemaBuilder.prototype.setAttrs = function (val) {
        this.attrs = val;
        return this;
    };
    SchemaBuilder.prototype.setListeners = function (val) {
        this.listeners = val;
        return this;
    };
    SchemaBuilder.prototype.get = function () {
        var _a = this, model = _a.model, fieldName = _a.fieldName, attrs = _a.attrs, listeners = _a.listeners;
        return this.schema.fieldSet[this.fieldName]({ model: model, fieldName: fieldName, attrs: attrs, listeners: listeners });
    };
    SchemaBuilder.prototype.getData = function () {
        var fieldContent = this.get();
        if (typeof fieldContent === 'string' || typeof fieldContent === 'number') {
            return fieldContent;
        }
        return null;
    };
    SchemaBuilder.prototype.getComponent = function () {
        var fieldContent = this.get();
        if (typeof fieldContent === 'object') {
            return fieldContent;
        }
        return null;
    };
    SchemaBuilder.prototype.getAjv = function () {
        var component = this.getComponent();
        return component && component.ajv ? component.ajv : null;
    };
    return SchemaBuilder;
}());
export { SchemaBuilder };
//# sourceMappingURL=SchemaBuilder.js.map